module.exports = __webpack_public_path__ + "img/20191220152024360截图20191220145145611.d8c21bad.jpg";